import React, { useState, useEffect } from 'react';
import { IconButton, Pagination } from '@axiom/ui';
import type { CandidateWorkFeedSearch } from '@axiom/validation';

export type WorkFeedPaginationProps = {
  meta?: CandidateWorkFeedSearch['meta'];
  name?: string;
};

export const WorkFeedPagination = ({
  meta,
  name = 'WORK_FEED_PAGINATION',
}: WorkFeedPaginationProps) => {
  const [pagination, setPagination] = useState({
    currentPage: meta?.currentPage,
    pageCount: meta?.pageCount,
  });

  const pageCount = pagination.pageCount ?? 0;
  const currentPage = pagination.currentPage ?? 0;

  useEffect(() => {
    setPagination({
      pageCount: meta?.pageCount,
      currentPage: meta?.currentPage,
    });
  }, [meta?.currentPage, meta?.pageCount]);

  const getPaginationLink = (incremental: number) => {
    const queryParams = window.location.search || '';
    const incrementPage = currentPage + incremental;
    const pageNumberClamped = Math.min(Math.max(incrementPage, 1), pageCount);
    const pageIndicator =
      pageNumberClamped > 1 ? `./page/${pageNumberClamped}` : './';
    return `${pageIndicator}${queryParams}`;
  };

  return (
    <div data-test={name}>
      <Pagination
        name={`${name}_PAGINATION`}
        currentPage={currentPage}
        totalPages={pageCount}
        nextButton={
          <IconButton
            icon="arrow-right"
            name="pagination-next-button"
            variation="minimal"
            pattern="secondary"
            to={getPaginationLink(1)}
          />
        }
        prevButton={
          <IconButton
            icon="arrow-left"
            name="pagination-prev-button"
            pattern="secondary"
            variation="minimal"
            to={getPaginationLink(-1)}
          />
        }
      />
    </div>
  );
};
